var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Box',[(!_vm.isLoading)?_c('Row',[_c('Column',[_c('ComplianceTable',{attrs:{"start":_vm.startComponent,"isAdmin":false}})],1)],1):_vm._e(),(_vm.isLoading)?_c('LoadingRow',[_vm._v(_vm._s(_vm.loadingMessage)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }